import { Avatar as MantineAvatar } from '@mantine/core'
import { UserAvatarProps } from './user-avatar.types'

const defaultAllowedInitialsColors = [
  'gray[4]',
  'red[4]',
  'red[8]',
  'grape',
  'violet[4]',
  'violet[8]',
  'indigo',
  'blue',
  'cyan',
]

export const UserAvatar = ({ ...props }: UserAvatarProps) => (
  <MantineAvatar
    allowedInitialsColors={defaultAllowedInitialsColors}
    {...props}
  />
)

UserAvatar.Group = MantineAvatar.Group
